
const Table = {
  MuiTableCell: {
    root: {
      whiteSpace: 'nowrap',
      paddingLeft: 12,
      paddingRight: 12,
    },
  },
  MuiTableRow: {
    root: {
      height: 52,
    },
    head: {
      height: 42,
    }
  }
}

const List = {
  // The goal is to be able to add divider under MuiListItemText
  MuiListItem: {
    root: {
      paddingTop: 8,
      paddingBottom: 8,

      '& .material-icons': {
        paddingBottom: 16,
      }
    },
    secondaryAction: {
      paddingRight: 0,
    }
  },
  MuiListItemText: {
    root: {
      padding: 0,
      margin: '0 16px',
      paddingBottom: 16,
    }
  },
};

export const muiTheme = (): any => ({
  typography: {
    useNextVariants: true,
    fontFamily: [
      '"Helvetica Neue"',
      'Roboto',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  palette: {
    common: {
      black: '#000',
      white: '#fff'
    },
    background: {
      paper: '#fff',
      default: '#fafafa'
    },
    primary: {
      light: 'rgba(237, 28, 36, 0.83)',
      main: 'rgba(237, 28, 36, 1)',
      dark: 'rgba(160, 28, 36, 1)',
      contrastText: '#fff'
    },
    secondary: {
      light: 'rgba(240, 46, 46, 0.86)',
      main: 'rgba(240, 46, 46, 1)',
      dark: 'rgba(200, 46, 46, 1)',
      contrastText: '#fff'
    },
    error: {
      light: 'rgba(255, 0, 0, 0.74)',
      main: 'rgba(255, 0, 0, 1)',
      dark: 'rgba(199, 0, 0, 1)',
      contrastText: '#fff'
    },
    text: {
      primary: 'rgba(0, 0, 0, 1)',
      secondary: 'rgba(0, 0, 0, 0.54)',
      disabled: 'rgba(0, 0, 0, 0.38)',
      hint: 'rgba(0, 0, 0, 0.38)'
    }
  },
  overrides: {
    ...Table,
    ...List,
  },
  props: {
    MuiGrid: {
      spacing: 16,
    },
  }
})



// WEBPACK FOOTER //
// ./src/conf/mui-theme.ts